import { render, staticRenderFns } from "./tenant-detail.vue?vue&type=template&id=9232545e&scoped=true"
import script from "./tenant-detail.vue?vue&type=script&lang=js"
export * from "./tenant-detail.vue?vue&type=script&lang=js"
import style0 from "./tenant-detail.vue?vue&type=style&index=0&id=9232545e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9232545e",
  null
  
)

export default component.exports